// extracted by mini-css-extract-plugin
export default {"logoContainer":"LandingPagesControls-logoContainer_MRG8_","logo":"LandingPagesControls-logo_t1NP6"};